import { DISCOVERY_URL } from "../../utils/urls.ts";

class CtaSection extends HTMLElement {
  connectedCallback() {
    const variant = this.getAttribute("variant") || "gradient";
    const titleEn = this.getAttribute("title-en") ||
      "Ready to Transform Your Business?";
    const titleLv = this.getAttribute("title-lv") ||
      "Gatavs Transformēt Savu Biznesu?";
    const titleIt = this.getAttribute("title-it") ||
      "Pronto a Trasformare il Tuo Business?";
    const subtitleEn = this.getAttribute("subtitle-en") || "";
    const subtitleLv = this.getAttribute("subtitle-lv") || "";
    const subtitleIt = this.getAttribute("subtitle-it") || "";
    const showDiscoveryBtn = this.getAttribute("show-discovery") !== "false";
    const showContactBtn = this.getAttribute("show-contact") !== "false";

    const bgClass = variant === "gradient"
      ? "bg-gradient-to-r from-indigo-600 to-purple-600"
      : variant === "dark"
      ? "bg-slate-900"
      : "bg-indigo-600";

    this.innerHTML = `
      <section class="${bgClass} py-20">
        <div class="container mx-auto px-6 text-center">
          <h2 class="text-3xl md:text-4xl font-bold text-white mb-6">
            <span data-en="${titleEn}" data-lv="${titleLv}" data-it="${titleIt}">${titleEn}</span>
          </h2>
          ${
      subtitleEn
        ? `
            <p class="text-xl text-white/90 max-w-3xl mx-auto mb-8">
              <span data-en="${subtitleEn}" data-lv="${subtitleLv}" data-it="${subtitleIt}">${subtitleEn}</span>
            </p>
          `
        : ""
    }
          <div class="flex flex-col md:flex-row justify-center gap-4">
            ${
      showDiscoveryBtn
        ? `
              <a href="${DISCOVERY_URL}" target="_blank" rel="noopener noreferrer"
                class="px-8 py-4 bg-white text-indigo-600 rounded-xl font-bold hover:bg-slate-100 transition-all shadow-lg hover:shadow-xl">
                <span data-en="Book Discovery Call" data-lv="Rezervēt Konsultāciju" data-it="Prenota Chiamata">Book Discovery Call</span>
              </a>
            `
        : ""
    }
            ${
      showContactBtn
        ? `
              <a href="index.html#contact"
                class="px-8 py-4 bg-transparent border-2 border-white text-white rounded-xl font-bold hover:bg-white/10 transition-all">
                <span data-en="Contact Us" data-lv="Sazināties" data-it="Contattaci">Contact Us</span>
              </a>
            `
        : ""
    }
            <slot></slot>
          </div>
        </div>
      </section>
    `;
  }
}

customElements.define("cta-section", CtaSection);
